// src/Pages/ViewMore.js
import React from "react";
import Header from "../Components/Header/Header";
import AllPosts from "../Components/ViewMoreAllPosts/AllPosts";

export default function ViewMore() {
  return (
    <>
      <Header />
      <div style={{ padding: 20 }}>
        <AllPosts />
      </div>
    </>
  );
}
